import { Text, VStack } from "native-base";
import React from "react";

import Breadcrumb from "@/components/atoms/Breadcrumb";
import Container from "@/components/organisms/Container";
import PromotionList from "@/components/organisms/PromotionList";
import StoreList from "@/components/organisms/StoreList";
import WebHeader from "@/components/organisms/WebHeader";
import { useAppNavigation } from "@/hooks/application/navigation";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

import { StoresByTypeScreenProps } from "./types";

const StoresByTypeWeb = ({
  storeType,
  promotionList,
  isLoadingPromotionList,
  storeList,
  isLoadingStoreList,
  onLoadMoreStores,
  onSelectStore,
}: StoresByTypeScreenProps) => {
  const { goBack } = useAppNavigation<HomeNavigation>();

  return (
    <Container px="1/5" Header={<WebHeader title={storeType?.nome} onPressBack={() => goBack()} />}>
      <VStack pt="4">
        <Breadcrumb
          routes={[
            { title: "Home", routeName: "home" },
            { title: storeType?.nome, routeName: "storesByType" },
          ]}
        />
        <Text fontSize="2xl" color="text.600" bold my="4" p="2">
          Promoções
        </Text>
        <PromotionList data={promotionList} isLoading={isLoadingPromotionList} />
        <Text fontSize="2xl" color="text.600" bold my="4" p="2">
          {storeType?.nome}
        </Text>
        <StoreList
          data={storeList}
          isLoading={isLoadingStoreList}
          onLoadMore={onLoadMoreStores}
          onSelect={onSelectStore}
        />
      </VStack>
    </Container>
  );
};

export default StoresByTypeWeb;
